import type { EnemyTemplate, CardDef } from "./types";


export const ENEMY_CARDS: Record<string, CardDef> = {
  goblin_slash: {
    id: "goblin_slash",
    name: "Укол",
    enhancements: {},
    kind: "attack",
    rarity: "common",
    hope: {
      cost: 1,
      description: "1d4 + Уровень урона.",
      effects: [{ type: "damage", base: 0, dice: { count: 1, sides: 4 }, levelScale: { mult: 1 } }],
    },
    fear: {
      cost: 1,
      description: "1d6 + 2×Уровень урона.",
      effects: [{ type: "damage", base: 0, dice: { count: 1, sides: 6 }, levelScale: { mult: 2 } }],
    },
  },

  goblin_poison_blade: {
    id: "goblin_poison_blade",
    name: "Отравленный клинок",
    enhancements: {},
    kind: "attack",
    rarity: "common",
    hope: {
      cost: 1,
      description: "1d6 + Уровень урона. Яд 1d4 × 2 хода.",
      effects: [
        { type: "damage", base: 0, dice: { count: 1, sides: 6 }, levelScale: { mult: 1 } },
        { type: "applyStatus", status: "poison", target: "enemy", stacks: 1, dieSides: 4, ttl: 2 },
      ],
    },
    fear: {
      cost: 1,
      description: "1d6 + 2×Уровень урона. Яд 1d6 × 3 хода.",
      effects: [
        { type: "damage", base: 0, dice: { count: 1, sides: 6 }, levelScale: { mult: 2 } },
        { type: "applyStatus", status: "poison", target: "enemy", stacks: 1, dieSides: 6, ttl: 3 },
      ],
    },
  },

  goblin_throw_knife: {
    id: "goblin_throw_knife",
    name: "Метательный нож",
    enhancements: {},
    kind: "attack",
    rarity: "common",
    hope: {
      cost: 1,
      description: "1d4 + Уровень урона.",
      effects: [{ type: "damage", base: 0, dice: { count: 1, sides: 4 }, levelScale: { mult: 1 } }],
    },
    fear: {
      cost: 1,
      description: "1d6 + 2×Уровень урона. При попадании: −1 к Ловкости цели до конца боя.",
      effects: [
        { type: "damage", base: 0, dice: { count: 1, sides: 6 }, levelScale: { mult: 2 } },
        { type: "applyStatus", status: "statDebuff", target: "enemy", stacks: 1, stat: "dexterity", delta: -1, onlyOnHit: true },
      ],
    },
  },

  goblin_stealth_strike: {
    id: "goblin_stealth_strike",
    name: "Скрытая атака",
    enhancements: {},
    kind: "attack",
    rarity: "uncommon",
    hope: {
      cost: 1,
      description: "1d10 + 2×Уровень урона. +2d4 если у цели есть дебафф.",
      effects: [{
        type: "damage", base: 0, dice: { count: 1, sides: 10 }, levelScale: { mult: 2 },
        bonusIfTargetHasDebuff: { dice: { count: 2, sides: 4 } },
      }],
    },
    fear: {
      cost: 1,
      description: "1d12 + 2×Уровень урона. +2d4 если у цели есть дебафф.",
      effects: [{
        type: "damage", base: 0, dice: { count: 1, sides: 12 }, levelScale: { mult: 2 },
        bonusIfTargetHasDebuff: { dice: { count: 2, sides: 4 } },
      }],
    },
  },

  wolf_bite: {
    id: "wolf_bite",
    name: "Укус",
    enhancements: {},
    kind: "attack",
    rarity: "common",
    hope: {
      cost: 1,
      description: "1d6 + Уровень урона.",
      effects: [{ type: "damage", base: 0, dice: { count: 1, sides: 6 }, levelScale: { mult: 1 } }],
    },
    fear: {
      cost: 1,
      description: "1d8 + 2×Уровень урона.",
      effects: [{ type: "damage", base: 0, dice: { count: 1, sides: 8 }, levelScale: { mult: 2 } }],
    },
  },

  wolf_gnaw: {
    id: "wolf_gnaw",
    name: "Грызть рану",
    enhancements: {},
    kind: "attack",
    rarity: "common",
    hope: {
      cost: 1,
      description: "1d4 + Уровень урона. Кровотечение 1d4 × 2 хода.",
      effects: [
        { type: "damage", base: 0, dice: { count: 1, sides: 4 }, levelScale: { mult: 1 } },
        { type: "applyStatus", status: "bleed", target: "enemy", stacks: 1, dieSides: 4, ttl: 2 },
      ],
    },
    fear: {
      cost: 1,
      description: "1d6 + 2×Уровень урона. Кровотечение 1d6 × 3 хода.",
      effects: [
        { type: "damage", base: 0, dice: { count: 1, sides: 6 }, levelScale: { mult: 2 } },
        { type: "applyStatus", status: "bleed", target: "enemy", stacks: 1, dieSides: 6, ttl: 3 },
      ],
    },
  },

  wolf_howl: {
    id: "wolf_howl",
    name: "Вой",
    enhancements: {},
    kind: "action",
    rarity: "uncommon",
    hope: {
      cost: 1,
      description: "+1 к попаданию до конца боя.",
      effects: [{ type: "applyStatus", status: "hitBoost", target: "self", stacks: 1 }],
    },
    fear: {
      cost: 1,
      description: "+2 к попаданию и +1d4 к урону до конца боя.",
      effects: [
        { type: "applyStatus", status: "hitBoost", target: "self", stacks: 2 },
        { type: "applyStatus", status: "damageDie", target: "self", stacks: 1, dieSides: 4 },
      ],
    },
  },

  wolf_jump: {
    id: "wolf_jump",
    name: "Прыжок-атака",
    enhancements: {},
    kind: "attack",
    rarity: "uncommon",
    hope: {
      cost: 1,
      description: "1d8 + Уровень урона. Снимает 1 армора.",
      effects: [
        { type: "damage", base: 0, dice: { count: 1, sides: 8 }, levelScale: { mult: 1 } },
        { type: "armorDebuff", value: 1 },
      ],
    },
    fear: {
      cost: 1,
      description: "1d10 + 2×Уровень урона. Снимает 2 армора.",
      effects: [
        { type: "damage", base: 0, dice: { count: 1, sides: 10 }, levelScale: { mult: 2 } },
        { type: "armorDebuff", value: 2 },
      ],
    },
  },
};


export const ENEMY_TEMPLATES: Record<string, EnemyTemplate> = {
  goblin: {
    id: "goblin",
    name: "Гоблин-шаман",
    level: 1,
    maxHp: 16,
    hpPerLevel: 6,
    armor: 0,
    evasion: 11,
    hitMod: 1,
    deck: ["goblin_slash", "goblin_poison_blade", "goblin_throw_knife", "goblin_stealth_strike"],
    lootTableId: "goblin",
    xpReward: 20,
    reputationReward: 1,
  },

  wolf: {
    id: "wolf",
    name: "Стая волков",
    level: 1,
    maxHp: 14,
    hpPerLevel: 5,
    armor: 1,
    evasion: 13,
    hitMod: 1,
    deck: ["wolf_howl", "wolf_bite", "wolf_gnaw", "wolf_jump"],
    lootTableId: "wolf",
    xpReward: 18,
    reputationReward: 1,
  },

  wolf_jumper: {
    id: "wolf_jumper",
    name: "Волк-прыгун",
    level: 1,
    maxHp: 40,
    hpPerLevel: 5,
    armor: 0,
    evasion: 10,
    hitMod: 3,
    deck: ["wolf_jump"],
    lootTableId: "wolf",
    xpReward: 10,
    reputationReward: 0,
  },
};

export function getEnemy(id: string): EnemyTemplate {
  const tmpl = ENEMY_TEMPLATES[id];
  if (!tmpl) throw new Error(`Unknown enemy id: ${id}`);
  return tmpl;
}


export function scaleEnemyToLevel(t: EnemyTemplate, level: number): EnemyTemplate {
  const lvl = Math.max(1, Math.floor(level));
  return {
    ...t,
    level: lvl,
    maxHp: t.maxHp + Math.max(0, lvl - 1) * t.hpPerLevel,
  };
}
